import React, { createContext, useState, useContext, ReactNode } from 'react';

interface FieldMarkersContextType {
  fieldMarkers: string[];
  setFieldMarkers: (markers: string[]) => void;
}

const defaultFieldMarkers = [
  '[USER INPUT TEXT]',
  '[TEXT OE]',
  '[TEXT OPEN END]',
  '[OPEN END]',
  '[OPEN END TEXT]',
  '[VIDEO OE]',
  '[VIDEO OPEN END]',
  '[OPEN END VIDEO]'
];

export const FieldMarkersContext = createContext<FieldMarkersContextType>({
  fieldMarkers: defaultFieldMarkers,
  setFieldMarkers: () => {} 
});

export const useFieldMarkers = () => useContext(FieldMarkersContext);

interface FieldMarkersProviderProps {
  children: ReactNode;
}

export const FieldMarkersProvider: React.FC<FieldMarkersProviderProps> = ({ children }) => {
  const [fieldMarkers, setFieldMarkers] = useState<string[]>(defaultFieldMarkers);

  return (
    <FieldMarkersContext.Provider value={{ fieldMarkers, setFieldMarkers }}>
      {children}
    </FieldMarkersContext.Provider>
  );
};